import React from 'react';
import Icon from '../../../components/AppIcon';

const DataRetentionTimeline = () => {
  const retentionPeriods = [
    {
      dataType: 'Beratungsprotokolle',
      period: '10 Jahre',
      reason: 'Gesetzliche Aufbewahrungspflicht nach BRAO',
      icon: 'FileText',
      color: 'bg-primary'
    },
    {
      dataType: 'Kontaktdaten',
      period: '3 Jahre',
      reason: 'Nachbetreuung und Rückfragen',
      icon: 'User',
      color: 'bg-accent'
    },
    {
      dataType: 'Zahlungsdaten',
      period: '10 Jahre',
      reason: 'Steuerrechtliche Aufbewahrung',
      icon: 'CreditCard',
      color: 'bg-success'
    },
    {
      dataType: 'Website-Analytics',
      period: '26 Monate',
      reason: 'DSGVO-konforme Speicherdauer',
      icon: 'BarChart3',
      color: 'bg-warning'
    },
    {
      dataType: 'Marketing-Daten',
      period: 'Bis Widerruf',
      reason: 'Einwilligung jederzeit widerrufbar',
      icon: 'Mail',
      color: 'bg-secondary'
    }
  ];

  return (
    <div className="bg-white rounded-lg shadow-professional border border-slate-200 p-6">
      <div className="flex items-center space-x-3 mb-6">
        <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
          <Icon name="Clock" size={20} color="var(--color-primary)" />
        </div>
        <div>
          <h2 className="text-xl font-semibold text-text-primary">Datenspeicherung Timeline</h2>
          <p className="text-sm text-text-secondary">Aufbewahrungszeiten verschiedener Datentypen</p>
        </div>
      </div>
      <div className="space-y-4">
        {retentionPeriods?.map((item, index) => (
          <div key={index} className="relative">
            {index !== retentionPeriods?.length - 1 && (
              <div className="absolute left-6 top-12 w-0.5 h-8 bg-slate-200"></div>
            )}
            <div className="flex items-start space-x-4">
              <div className={`flex items-center justify-center w-12 h-12 ${item?.color} rounded-lg text-white`}>
                <Icon name={item?.icon} size={20} />
              </div>
              <div className="flex-1">
                <div className="flex items-center justify-between">
                  <h3 className="font-semibold text-text-primary">{item?.dataType}</h3>
                  <span className="px-3 py-1 bg-muted text-text-secondary text-sm rounded-full font-medium">
                    {item?.period}
                  </span>
                </div>
                <p className="text-sm text-text-secondary mt-1">{item?.reason}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 p-4 bg-muted/50 rounded-lg">
        <div className="flex items-start space-x-3">
          <Icon name="Info" size={16} color="var(--color-primary)" className="mt-0.5" />
          <div>
            <p className="text-sm text-text-secondary">
              <strong>Hinweis:</strong> Sie haben jederzeit das Recht auf Auskunft, Berichtigung oder Löschung Ihrer Daten. 
              Kontaktieren Sie uns unter <span className="text-primary">datenschutz@advocall.de</span> für entsprechende Anfragen.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataRetentionTimeline;